import { UseExistedHolidayGroupModal } from '@thinknet-gmbh/platform-common-ui';

import { useTranslation } from 'react-i18next';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useCopyHolidayLocationsInCompany } from 'src/hooks/holiday-manager/copy-holiday-locations-in-compnay.hook';
import { useGetAllHolidaysGroups } from 'src/hooks/holiday-manager/get-holiday-groups.hook';

const UseExistedHolidayGroup = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation(['common', 'settings']);

  const { holidaysGroups } = useGetAllHolidaysGroups();
  const copyHolidayLocationsInCompany = useCopyHolidayLocationsInCompany();

  const currentCompanyId = useGetCurrentCompanyId();

  const onSubmitForm = (values: any) => {
    copyHolidayLocationsInCompany({
      variables: { payload: { companyId: currentCompanyId, ...values } },
    });
  };

  return (
    <UseExistedHolidayGroupModal
      onClose={onClose}
      t={t}
      holidaysGroups={holidaysGroups}
      onFinish={onSubmitForm}
    />
  );
};

export default UseExistedHolidayGroup;
